import { memo } from 'react';
// @mui

function PolicyIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.9316 0C20.4618 0 20.9703 0.210507 21.3453 0.585255L31.057 10.2897C31.4324 10.6648 31.6433 11.1737 31.6433 11.7044V29.5814C31.6433 31.7392 29.8591 33.4884 27.6582 33.4884H7.16334C4.96242 33.4884 3.17822 31.7392 3.17822 29.5814V3.90698C3.17822 1.74921 4.96242 0 7.16334 0H19.9316Z"
        fill="#919EAB"
      />
      <g filter="url(#filter0_d_2714_12795)">
        <path
          d="M29.961 10.0234C30.274 10.339 30.0505 10.8755 29.606 10.8755H24.9457C22.7879 10.8755 20.8414 8.97762 20.8414 6.87375V2.04315C20.8414 1.59671 21.382 1.37408 21.6964 1.69105L29.961 10.0234Z"
          fill="white"
          fillOpacity="0.24"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0387 14.2244H20.7596V15.6895H9.0387V14.2244ZM9.0387 17.1546H20.7596V18.6197H9.0387V17.1546ZM9.0387 20.0848H20.7596V21.55H9.0387V20.0848ZM9.0387 23.0151H14.8992V24.4802H9.0387V23.0151Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0896 31.8368C20.4155 28.9516 20.889 25.3014 23.2439 22.9387C25.5988 20.5761 29.2474 20.0906 32.1382 21.7553C35.0289 23.42 36.4404 26.8194 35.5789 30.0421C34.7174 33.2647 31.798 35.5064 28.4622 35.5066C25.8331 35.5164 23.4007 34.1157 22.0896 31.8368Z"
        fill="#22C55E"
      />
      <path
        d="M26.7899 30.7624C26.6325 30.7626 26.483 30.6937 26.381 30.574L24.6006 28.4882C24.4744 28.3425 24.4359 28.1402 24.4999 27.9583C24.5639 27.7764 24.7205 27.6427 24.9102 27.6081C25.0999 27.5735 25.2936 27.6432 25.4178 27.7907L26.8575 29.4774L31.577 25.6377C31.7257 25.5152 31.9287 25.4817 32.1089 25.55C32.2891 25.6182 32.4189 25.7778 32.4491 25.9681C32.4793 26.1584 32.4053 26.3503 32.2551 26.471L27.1288 30.6419C27.0331 30.72 26.9134 30.7626 26.7899 30.7624Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_2714_12795"
          x="18.8414"
          y="1.54215"
          width="13.2655"
          height="13.3334"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2714_12795" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2714_12795" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default memo(PolicyIcon);
